type Change = { id: string; type: string };

/** Shared v11 change loop: drop removed items, apply the rest in order, keep untouched items by identity. */
export const applyItemChanges = <TItem extends { id: string }, TChange extends Change>(
  changes: readonly TChange[],
  items: readonly TItem[],
  applyChange: (item: TItem, change: TChange) => TItem,
): TItem[] => {
  if (changes.length === 0) return [...items];
  const changesById = new Map<string, TChange[]>();
  changes.forEach((change) => changesById.set(change.id, [...(changesById.get(change.id) ?? []), change]));
  return items.flatMap((item) => {
    const itemChanges = changesById.get(item.id);
    if (!itemChanges) return [item];
    if (itemChanges.some((change) => change.type === 'remove')) return [];
    return [itemChanges.reduce(applyChange, item)];
  });
};
